import React from 'react';
import { DATETIME_FORMAT } from '../shared/constants';
import dayjs from 'dayjs';

const OrderCreatedToast = ({ user, order }) => {
    const handleUserClick = (e) => {
        e.preventDefault();
        window.location.href = `/user/detail/${user.id}`;
    };

    const handleOrderClick = (e) => {
        e.preventDefault();
        window.location.href = `/order/${order.id}`;
    };

    return (
        <div className="d-flex flex-wrap align-items-center">
            <a
                href={`/user/detail/${user.id}`}
                onClick={handleUserClick}
                className="text-primary text-decoration-underline fw-bold me-1"
                style={{ cursor: 'pointer' }}
            >
                {user.fullName || `${user.firstName} ${user.lastName}`}
            </a>
            <span className="me-1">make a</span>
            <a
                href={`/order/${order.id}`}
                onClick={handleOrderClick}
                className="text-primary text-decoration-underline fw-bold mx-1"
                style={{ cursor: 'pointer' }}
            >
                order
            </a>
            <span className="ms-1 text-muted small">
                on {dayjs(order.createdAt).format(DATETIME_FORMAT)}
            </span>
        </div>
    );
};

export default OrderCreatedToast;
